import React, { Component } from "react";
import { Col } from "react-bootstrap";

export default class ItemModal extends Component {
  constructor() {
    super();
    this.state = { isHovered: false };
    this.toggleHover = this.toggleHover.bind(this);
  }

  toggleHover() {
    this.setState(prevState => ({ isHovered: !prevState.isHovered }));
  }

  render() {
    return (
      <Col
        md="3"
        className="cite__myDatails"
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        style={{ padding: 0 }}
      >
        {this.state.isHovered ? (
          <div
            className="cite__myDatailsDesc"
            style={{
              backgroundColor: "rgb(245, 244, 244)",
              height: 395,
              padding: 20,
              paddingTop: 50
            }}
          >
            <img height={60} alt="icon" src={this.props.data.pic} />
            <p style={{ marginTop: 50 }}>{this.props.data.full_text}</p>
          </div>
        ) : (
          <div className="cite__myDatailsDesc">
            <img height={60} alt="icon" src={this.props.data.pic} />
            <p style={{ marginTop: 50 }}>{this.props.data.text}</p>
          </div>
        )}
      </Col>
    );
  }
}
